import { render, staticRenderFns } from "./AppAiReportDetails.vue?vue&type=template&id=f2cede8e&scoped=true"
import script from "./AppAiReportDetails.vue?vue&type=script&lang=ts"
export * from "./AppAiReportDetails.vue?vue&type=script&lang=ts"
import style0 from "./AppAiReportDetails.vue?vue&type=style&index=0&id=f2cede8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cede8e",
  null
  
)

export default component.exports